export default "__VITE_ASSET__039864b6__"